import { MerchantsCardGrid } from "@/routes/(app)/_admin-layout/-components/merchants-card-grid";
import { isErr } from "@/lib/errors";
import { StorageUtility } from "@/lib/storage";
import { volume } from "@/lib/volume-api-2";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useEffect } from "react";
import { toast } from "sonner";
import { redirectToSignIn } from "@/lib/auth";

export const Route = createFileRoute("/(app)/_admin-layout/admin")({
  component: () => <AdminComponent />,
  beforeLoad: async ({ context, search }) => {
    /**
     * If there happens to be an applicationId in the search params
     * Remove it
     */

    if ((search as { applicationId?: string }).applicationId) {
      throw redirect({
        to: "/admin",
        search: {},
      });
    }
    return context;
  },
  loader: async ({ context }) => {
    const merchantsResponse = await volume.admin.GetMerchants({
      accessToken: context.accessToken,
    });
    if (isErr(merchantsResponse)) {
      if (merchantsResponse.type === "UNAUTHORIZED") {
        toast.error(
          "There was an error fetching merchants, please sign in again.",
        );
        throw redirectToSignIn(false);
      }
      throw new Error("Failed to fetch merchants");
    }
    return merchantsResponse;
  },
});

const AdminComponent = () => {
  useEffect(() => {
    StorageUtility.removeItems([
      "v_applications_v1",
      "v_companyName_v1",
      "v_merchantId_v1",
      "v_email_v1",
    ]);
  }, []);
  return <MerchantsCardGrid />;
};
